import React, { useState } from 'react';
import { GRID_FILTER_KEYS } from '../../../Base/Components/GridFilter/gridFilterKeys';
import GridFilterItem from '../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../Base/Enums/GridFilterItemType.enum';
import GridFilter from '../../../Base/Components/GridFilter/GridFilter';
// @ts-ignore
import styles from './PatientsGroupsFilter.module.scss';

interface PatientsGroupsFilterValues {
	fulltext: string;
}

interface Props {
	onFilter: (values: PatientsGroupsFilterValues) => void;
	customButtons?: React.ReactElement;
}

const PatientsGroupsFilter: React.FC<Props> = ({ onFilter, customButtons }) => {
	const [searchTimeout, setSearchTimeout] = useState<
		NodeJS.Timeout | undefined
	>(undefined);
	const onFilterData = (values: any) => {
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		const filter = () => {
			onFilter(values);
		};

		setSearchTimeout(setTimeout(filter, 300));
	};

	return (
		<GridFilter
			onChange={onFilterData}
			storageKey={GRID_FILTER_KEYS.PATIENTS_GROUPS_FILTER}
			customButtons={customButtons}
			formClassName={styles.filterForm}>
			<GridFilterItem
				type={GridFilterItemType.FULLTEXT}
				width={500}
				enableAutocomplete
				customLabel='base.searchGroup'
				customPlaceholder='base.inputGroupName'
			/>
		</GridFilter>
	);
};

export default PatientsGroupsFilter;
